import CustomForm from '../../lib/FormValidator/Form/CustomForm';
import { PlanillaPartidoOficialAuxiliar } from '../../system/PlanillaPartidoOficialAuxiliar/PlanillaPartidoOficialAuxiliar';
import { PlanillaPartidoOficialAuxiliarAssertions } from '../../system/PlanillaPartidoOficialAuxiliar/PlanillaPartidoOficialAuxiliarAssertions';
class PlanillaPartidoOficialAuxiliarForm extends CustomForm {
  protected constructor(
    ppoa_id: string | null,
    ppoa_ppid: number,
    ppoa_eqid: number,
    ppoa_nombre: string,
    ppoa_apellido: string,
    ppoa_dni: string,
    ppoa_orden: string
  ) {
    const pla = PlanillaPartidoOficialAuxiliarAssertions.build();
    super('PlanillaPartidoOficialAuxiliar', pla);
    this.addInputAsserted('ppoa_id', ppoa_id);
    this.addInputAsserted('ppoa_ppid', ppoa_ppid);
    this.addInputAsserted('ppoa_eqid', ppoa_eqid);
    this.addInput('ppoa_nombre', ppoa_nombre);
    this.addInput('ppoa_apellido', ppoa_apellido);
    this.addInput('ppoa_dni', ppoa_dni);
    this.addInput('ppoa_orden', ppoa_orden);
  }

  private static build(
    ppoa_id: string | null,
    ppoa_ppid: number,
    ppoa_eqid: number,
    ppoa_nombre: string,
    ppoa_apellido: string,
    ppoa_dni: string,
    ppoa_orden: string
  ) {
    return new this(ppoa_id, ppoa_ppid, ppoa_eqid, ppoa_nombre, ppoa_apellido, ppoa_dni, ppoa_orden);
  }

  static initialize(eqId: number) {
    return this.build(null, 0, eqId, '', '', '', '');
  }

  static with(
    ppoa_id: string | null,
    ppoa_ppid: number,
    ppoa_eqid: number,
    ppoa_nombre: string,
    ppoa_apellido: string,
    ppoa_dni: string,
    ppoa_orden: string
  ) {
    return this.build(ppoa_id, ppoa_ppid, ppoa_eqid, ppoa_nombre, ppoa_apellido, ppoa_dni, ppoa_orden);
  }

  getIdInput() {
    return this.getInputByName('ppoa_id');
  }

  getPpidInput() {
    return this.getInputByName('ppoa_ppid');
  }

  getEqidInput() {
    return this.getInputByName('ppoa_eqid');
  }

  getNombreInput() {
    return this.getInputByName('ppoa_nombre');
  }

  getApellidoInput() {
    return this.getInputByName('ppoa_apellido');
  }

  getDniInput() {
    return this.getInputByName('ppoa_dni');
  }

  getOrdenInput() {
    return this.getInputByName('ppoa_orden');
  }

  toPlanillaPartidoOficialAuxiliar(): PlanillaPartidoOficialAuxiliar {
    return PlanillaPartidoOficialAuxiliar.createFrom(
      this.getIdInput().getValue(),
      this.getPpidInput().getValue(),
      this.getEqidInput().getValue(),
      this.getNombreInput().getValue(),
      this.getApellidoInput().getValue(),
      this.getDniInput().getValue(),
      this.getOrdenInput().getValue(),
      false
    );
  }
}

export default PlanillaPartidoOficialAuxiliarForm;
